// 301 redirect map: legacy WordPress paths (prosperdoorrepair.com) -> new site URLs.
// Used in-app for any old indexed URL that lands on the SPA. The deployable
// server-level 301 rules (Apache/Nginx/_redirects) live in /app/REDIRECTS.md.
import { CITIES } from "./cities";
import { REMOVED_CITY_MAP } from "./local";
import GENERATED_POSTS from "./blogGenerated.json";

const CITY_SLUGS = new Set(CITIES.map((c) => c.slug));
const MIGRATED_POST_SLUGS = new Set(GENERATED_POSTS.map((p) => p.slug));

export const REDIRECTS = {
  // Legacy residential/commercial service pages -> closest new service+city page
  "/residential-garage-door-services": "/garage-door-repair/prosper",
  "/residential-garage-door-repair": "/garage-door-repair/prosper",
  "/residential-garage-door-installation": "/new-garage-door-installation/prosper",
  "/residential-garage-door-openers": "/garage-door-opener-repair/prosper",
  "/commercial-garage-door-services": "/garage-door-repair/prosper",
  "/commercial-garage-door-installation": "/new-garage-door-installation/prosper",
  "/commercial-garage-door-repair": "/garage-door-repair/prosper",
  "/commercial-garage-door-opener": "/garage-door-opener-repair/prosper",
  "/garage-door-repair-prosper-tx": "/garage-door-repair/prosper",
  "/garage-door-spring-repair-prosper-texas": "/garage-door-spring-repair/prosper",

  // Static pages
  "/about": "/",
  "/about-us": "/",
  "/contact": "/#quote",
  "/contact-us": "/#quote",
  "/blog": "/garage-door-tips",
  "/sitemap": "/",

  // Microsite path equity -> dedicated city pages (when old paths hit the SPA)
  "/mckinney-overhead-door": "/garage-door-repair/prosper",
  "/mckinney": "/garage-door-repair/prosper",
  "/melissa": "/garage-door-repair/celina",
  "/melissa-doors": "/garage-door-repair/celina",
};

export const resolveRedirect = (pathname) => {
  if (!pathname) return null;
  const key = pathname.replace(/\/+$/, "").toLowerCase() || "/";

  // Legacy WP location pages: /contact/garage-door-repair-in-{slug}
  const m = key.match(/^\/contact\/garage-door-repair-in-(.+)$/);
  if (m) {
    const slug = m[1];
    return CITY_SLUGS.has(slug)
      ? `/garage-door-repair/${slug}`
      : `/garage-door-repair/${REMOVED_CITY_MAP[slug] || "prosper"}`;
  }

  // Migrated old blog posts lived at the root; now republished under /garage-door-tips/
  const postSlug = key.replace(/^\//, "");
  if (MIGRATED_POST_SLUGS.has(postSlug)) return `/garage-door-tips/${postSlug}`;

  return REDIRECTS[key] || null;
};

// Keep the visitor's query string (UTM tags) on a redirect, placed before any #hash.
export const withSearch = (to, search) => {
  if (!search || to.includes("?")) return to;
  const [path, hash] = to.split("#");
  return `${path}${search}${hash !== undefined ? `#${hash}` : ""}`;
};

